import { useTranslation } from 'react-i18next';
import { Button } from '../../../../2-component';
import { Grid } from '../../../../1-primative';

type SubTradeRequestsActionsProps = {
  onVerifySubTradeRequests: () => void;
  selected: any[];
  loading: boolean;
  verifyLoading: boolean;
};

const SubTradeRequestsActions = ({
  onVerifySubTradeRequests,
  selected,
  loading,
  verifyLoading,
}: SubTradeRequestsActionsProps) => {
  const { t } = useTranslation(['rebalanceReportV2']);

  return (
    <Grid container gap={1} justifyContent='flex-end'>
      <Grid item xs='auto'>
        <Button
          onClick={onVerifySubTradeRequests}
          label={t('actions.verify')}
          variant='filled'
          disabled={!selected.length || loading || verifyLoading}
        />
      </Grid>
      <Grid item xs='auto'>
        <Button
          label={t('actions.cancelTrades')}
          variant='filled'
          disabled={!selected.length}
        />
      </Grid>
    </Grid>
  );
};

export default SubTradeRequestsActions;
